export default "__VITE_ASSET__ca6725d0__"